module.exports = __webpack_public_path__ + "static/media/boat-img-34.1bbd0fb4.jpg";